import style from "../../../layout/content/post/creator.module.scss";

interface Props {
  name: string;
  setName: (_: string) => void;
}

export function PopupNameField({ name, setName }: Props) {
  return (
    <input
      className={style.inputField}
      value={name}
      required={true}
      onChange={(e) => setName(e.target.value)}
      placeholder={"등록할 팝업명 입력"}
    />
  );
}
